export const ALL_POSSIBLE_USER_ROLES = ['ROLE_WEBSHOP_USER', 'GUEST', 'ROLE_ADMIN'] as const;
